import React, { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import Navbar from "../components/layout/Navbar";
import Footer from "../components/layout/Footer";
import ProductCard from "../components/ProductCard";
import { api } from "../api/client";
import { ArrowRight } from "lucide-react";

const ConditionDetail = () => {
    const { slug } = useParams();
    const [data, setData] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        setLoading(true);
        api.get(`/conditions/${slug}?sample_size=24`).then((r) => setData(r.data)).finally(() => setLoading(false));
    }, [slug]);

    if (loading || !data) {
        return (
            <div className="min-h-screen bg-white dark:bg-[#0B0B12]">
                <Navbar />
                <main className="mx-auto max-w-6xl px-6 py-12 lg:px-12 text-sm text-zinc-500">Loading…</main>
            </div>
        );
    }
    const c = data.condition;

    return (
        <div className="min-h-screen bg-white dark:bg-[#0B0B12]">
            <Navbar />
            <main className="mx-auto max-w-6xl px-6 py-12 lg:px-12">
                <Link to="/conditions" className="text-xs text-zinc-500 hover:underline">← All conditions</Link>
                {/* Hero */}
                <section className={`mt-3 relative overflow-hidden rounded-3xl bg-gradient-to-br ${c.hero_color} p-8 text-white shadow-sm`} data-testid="condition-hero">
                    <div className="flex items-start gap-4">
                        <span className="text-5xl drop-shadow-sm" aria-hidden>{c.icon_emoji}</span>
                        <div>
                            <p className="text-xs font-semibold uppercase tracking-wider text-white/80">Condition</p>
                            <h1 className="mt-1 text-3xl font-semibold tracking-tight sm:text-4xl" style={{ letterSpacing: "-0.02em" }}>{c.name}</h1>
                            <p className="mt-2 max-w-xl text-sm text-white/90">{c.short_description}</p>
                            <p className="mt-3 text-xs text-white/80">{data.product_count} curated product{data.product_count === 1 ? "" : "s"}</p>
                        </div>
                    </div>
                </section>

                {/* Curated grid */}
                <section className="mt-10">
                    <div className="mb-4 flex items-end justify-between gap-3">
                        <h2 className="text-lg font-semibold text-zinc-900 dark:text-zinc-50">Recommended products</h2>
                        <Link to={`/products?condition=${c.slug}`} className="inline-flex items-center gap-1 text-sm font-medium text-brand-700 hover:underline">
                            Browse all <ArrowRight className="h-3.5 w-3.5" />
                        </Link>
                    </div>
                    {data.sample_products.length === 0 ? (
                        <p className="rounded-2xl border border-dashed border-zinc-200 p-8 text-center text-sm text-zinc-500">
                            No products tagged for this condition yet. Check back soon.
                        </p>
                    ) : (
                        <div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4" data-testid="condition-products-grid">
                            {data.sample_products.map((p) => <ProductCard key={p.id} product={p} />)}
                        </div>
                    )}
                </section>
            </main>
            <Footer />
        </div>
    );
};

export default ConditionDetail;
